import { useQuery } from '@tanstack/react-query';
import { firestoreService } from '../services/firestore.service';

export const useCategories = () => {
  return useQuery({
    queryKey: ['categories'],
    queryFn: () => firestoreService.getCategories(),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export const useCategoryById = (id: string) => {
  return useQuery({
    queryKey: ['category', id],
    queryFn: () => firestoreService.getCategoryById(id),
    enabled: !!id,
  });
};
